import { alpha, styled as muiStyle } from "@mui/material/styles";
import { Tab, Tabs, TabsProps as MuiTabsProps } from '@mui/material';

export const StyledTab = muiStyle(Tab)<MuiTabsProps>(({ theme, orientation }) => ({
    position: `relative`,
    zIndex: 1,
    maxWidth: `none`,
    minWidth: `0`,
    minHeight: `0`,
    width: 32,
    height: 32,
    padding: `0`,
  backgroundColor: `transparent`,
  borderRadius: `50%`,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary[800], 0.08),
    },
    '&.Mui-selected': {
      borderBottomColor: `transparent`,
      color: theme.palette.common.black,
      backgroundColor: `transparent`,
    },


}));

export const StyledTabs = muiStyle(Tabs)<MuiTabsProps>(({ theme }) => ({
  display:`inline-flex`,
  minHeight: `0`,
  padding: 4,
  borderRadius: 3,
  backgroundColor: theme.palette.grayscaleSecondary[50],
  '& .MuiTabs-indicator' : {
    width: `28px !important`,
    height: 28,
    bottom: 0,
    top: `0`,
    margin: 2,
    borderRadius: 2,
    boxShadow:` 0 2px 4px 0 rgba(0, 0, 0, 0.16)` ,
    backgroundColor:  theme.palette.common.white
  },

}));
